import React from 'react';

const StyledInput = ({ placeholder, style, label, type, value, onChange, disabled }) => {

    const focusAndClear = () => {
        onChange("");
    }

    if (type === "textarea") return <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 10 }}>
        <textarea placeholder={placeholder} style={{
            border: "1px solid #ccc",
            padding: 4,
            width: "100%",
            minHeight: 50,
            display: "inline-block",
            boxSizing: "border-box",
            fontSize: 14,
            fontFamily: "inherit", ...style,
        }} disabled={disabled} value={value} onChange={e => onChange(e.target.value)} />
    </div>;

    if (type === "checkbox") return <div style={{ position: "relative", overflow: "hidden", marginBottom: 10 }}>

        <input style={{
            opacity: 0,
            position: "absolute",
            zIndex: 1,
            width: 200,
            height: 200,
        }} type={type} checked={!!value} onChange={e => onChange(e.target.checked)} />

        <label style={{
            cursor: "pointer",
            padding: "4px 10px",
            borderRadius: 4,
            border: !value ? "1px solid #000" : "1px solid #000",
            backgroundColor: !value ? "green" : "#000",
            color: !value ? "#fff" : "#fff",
            fontSize: 16,
            width: "auto",
            height: 20,
            display: "inline-block",
            textAlign: "center",
        }} disabled={disabled} >{label[!value ? 1 : 0]}</label>

    </div>;

    if (type === "number") return <div style={{ display: "flex", alignItems: "flex-end", gap: 10, marginBottom: 10, width: 80 }}>

        <input style={{
            border: "none",
            borderBottom: "1px solid #ccc",
            padding: 4,
            width: "100%",
            minWidth: 60,
            display: "inline-block",
            fontSize: 18, ...style,
        }} placeholder="0.00"
        disabled={disabled} type={type} value={value} onChange={e => onChange(e.target.value)} />

    </div>;

    return <div style={{ display: "flex", alignItems: "flex-end", gap: 10, marginBottom: 10, flex: 1, ...style }}>

        <input style={{
            border: "none",
            borderBottom: "1px solid #ccc",
            padding: 4,
            width: "100%",
            minWidth: 50,
            display: "inline-block",
            fontSize: 18, ...style
        }} placeholder={placeholder}
        disabled={disabled} type={type} value={value} onChange={e => onChange(e.target.value)} />

    </div>;

}
export default StyledInput;